import { Quill } from 'react-quill';

const { Attributor, Scope } = Quill.import('parchment');

const LineHeightWhitelist = [
  '10px',
  '15px',
  '18px',
  '20px',
  '32px',
  '36px',
  '40px',
  '48px',
  '56px',
  '64px',
  '72px',
  '80px',
  '96px',
];

const config = {
  scope: Scope.INLINE,
  whitelist: LineHeightWhitelist,
};

export const LineHeightClass = new Attributor.Class(
  'line-height',
  'span',
  config,
);

export const LineHeightStyle = new Attributor.Style(
  'line-height',
  'line-height',
  config,
);
